import * as yup from 'yup'

import { AnyObject, YupConfig } from 'data/Common'

export const createYupSchema = (schema: AnyObject, config: YupConfig) => {
    const { id, validationType, validations = [] } = config

    if (!yup[validationType]) {
        return schema
    }
    let validator = yup[validationType]()
    validations.forEach(validation => {
        const { params, type } = validation
        if (!validator[type]) {
            return
        }

        validator = validator[type](...params)
    })
    schema[id] = validator
    return schema
}
